import { IUserClient } from "@multiweb/clients/user";
import { ICommunicationManager } from "OW.Remoting/Remoting/ICommunicationManager";
import { UserClient } from "./UserClient";

export function defaultFactory(communicationManager: ICommunicationManager): IUserClient {
    return new UserClient(communicationManager);
}
